<div class="overflow-hidden">
  @if (event$(); as event) {
    <app-event-header
      [subTitle]="event.eventType?.name"
      [title]="event.title || ''"
      [image]="event.image"
      [youtubeUrl]="event.videoUrl"
      [intro]="event.description"
      [mobileSubTitleSuffix]="event.startDate | eventDate: event.endDate"
      [eventLabel]="event.label"
    >
      <app-breadcrumbs [backButton]="true" [breadcrumbs]="breadcrumbs()" above></app-breadcrumbs>

      @if (event.cta?.button?.routerLink || event.cta?.text) {
        <div class="card event-header-cta" content>
          <span>{{ event.cta?.text || ('agenda-detail-kaarten-bestellen-prefix' | fromDictionary) }}</span>

          <fstr-link class="d-inline-block ms-auto" cssClasses="button button--primary" [button]="event.cta?.button!"></fstr-link>
        </div>
      }

      <div below>
        <app-event-practical-info [event]="event"></app-event-practical-info>
      </div>
    </app-event-header>

    <section class="container pt-4 pt-md-0">
      <h2 class="sr-only">Over dit agenda-item</h2>

      @if (event.text) {
        <ngx-dynamic-hooks
          class="markdown-content d-block text-max-width-sm mx-auto p-3 p-md-4"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="event.text! | resizeHtmlImages | stripEmbed: cookiePreferences$() || undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>
      }

      <!-- Other event dates
      @if ((event.eventDates?.length || 0) > 1) {
        <section class="section-outset-y">
          <h3 class="h4">{{ 'event-detail-meer-data' | fromDictionary }}</h3>
          <ul>
            @for (date of event.eventDates; track $index) {
              <li>
                <a
                  [class.text-black]="(date | date: 'dd-MM-yyyy') === (event.startDate | date: 'dd-MM-yyyy')"
                  [routerLink]="['/', 'agenda', event.id, date | date: 'dd-MM-yyyy', event.title | urlRewrite]"
                >
                  {{ date | eventDate: event.endDate }}
                </a>
              </li>
            }
          </ul>
        </section>
      }-->

      <div class="d-md-none mt-3" below>
        <app-event-practical-info [event]="event" [showOnlyImportantInfo]="isShortText()"></app-event-practical-info>
      </div>

      @if (event.cta?.button?.url && event.text.length > 1000) {
        <div class="card mt-auto event-header-cta bg-primary-subtle text-max-width-sm mx-auto" content>
          <span>{{ event.cta?.text || ('agenda-detail-kaarten-bestellen-prefix' | fromDictionary) }}</span>

          <fstr-link class="d-inline-block ms-auto" cssClasses="button button--primary  " [button]="event.cta!.button"></fstr-link>
        </div>
      }
    </section>

    @if (hasMoreDates()) {
      <section class="my-5 container" id="data">
        <div class="text-max-width-sm mx-auto px-3 px-md-4">
          <strong class="fw-normal text-secondary d-inline-block mb-1">
            {{ 'agenda-detail-meer-data-lijst-kleine-titel' | fromDictionary }}
          </strong>
          <h2 class="h4 mb-4">{{ 'agenda-detail-meer-data-lijst-titel' | fromDictionary }}</h2>

          <ul class="list">
            @for (eventDateOption of event?.eventDates | slice: 0 : showDateCount(); track $index) {
              <li class="list__item">
                <a
                  class="list__item__inner"
                  [routerLink]="['/agenda', event.id, eventDateOption | date: 'dd-MM-yyyy', event.title | urlRewrite]"
                >
                  <span class="list__item__label">{{ eventDateOption | eventDate }}</span>

                  <fstr-icon class="chip chip--secondary chip--sm ms-auto" anchor="icon-arrow-right"></fstr-icon>
                </a>
              </li>
            }

            @if (showDateCount() < (event?.eventDates?.length || 0)) {
              <li class="text-center mt-3">
                <button class="button button--secondary button--xs" (click)="showDateCount.set(showDateCount() + 10)">
                  {{ 'agenda-detail-meer-data-lijst-laad-meer' | fromDictionary }}
                </button>
              </li>
            }
          </ul>
        </div>
      </section>
    }

    <app-event-metadata class="d-block mt-3" [event]="event"></app-event-metadata>

    @if (relatedEvents$().length) {
      <app-content-block-agenda
        class="section-outset-t d-block"
        [block]="{
          id: 0,
          title: ('agenda-detail-gerelateerd-titel' | fromDictionary),
          blockType: '',
          events: relatedEvents$(),
        }"
        [index]="0"
      ></app-content-block-agenda>
    }
  }
  <!--<pre>{{ event$() | json }}</pre>-->
</div>
